import { AdminCommonTheme } from './Common';

export const AdminTheme = {
    Common: AdminCommonTheme,
}